module.exports = __webpack_public_path__ + "img/slider_invoiceweb.a564f2be.png";